export default __webpack_public_path__ + "7651f2e2e3824efb4ad77a1c8a39b0a4.png";